// extracted by mini-css-extract-plugin
module.exports = {"falloutRates__item":"falloutRates_falloutRates__item__Yu2NF"};